import { ApiTablePage } from 'components/ApiTablePage/ApiTablePage';
import { Button } from 'components/Button/Button';
import { createFrontendOnlyColumn } from 'components/Table/columns/frontendOnlyColumn';
import { useLocale } from 'containers/App/LocaleContext';
import { DownloadConfigButton } from 'pages/Management/SavedConfigConsistency/DownloadConfigButton';
import { downloadConfig } from 'pages/Management/SavedConfigConsistency/helpers/downloadConfig';
import { useState } from 'react';
import type { FC } from 'react';
import { useApi } from 'utils/request/useApi';
import { useTableEndpoint } from 'utils/table/useTableEndpoint';
import { SavedConfigConsistencyDiffModal } from './SavedConfigConsistencyDiffModal';

export const savedConfigConsistencyApiEndpoint =
  '/tables/management/configuration/saved';

export const SavedConfigConsistencyPage: FC = () => {
  const savedCcMsg = useLocale().managementSavedConfigConsistency;

  const api = useApi();

  const [diffHost, setDiffHost] = useState<{
    blobKey: string;
    hostname: string;
  } | null>(null);

  const endpoint = useTableEndpoint({
    apiEndpoint: savedConfigConsistencyApiEndpoint,
    alternative: (origEndpoint) => ({
      id: origEndpoint.id,
      columns: [
        '...',
        createFrontendOnlyColumn({
          key: 'configAction',
          disabledSort: true,
          title: savedCcMsg.configActionColumnTitle,
          webDependencies: [
            'blobKey',
            'currentConfigExists',
            'id',
            'startupConfigExists',
            'status',
          ],
          render: (row) => (
            <div className='flex flex-row items-center'>
              <DownloadConfigButton
                disabled={!row.startupConfigExists}
                downloadConfigCallback={() =>
                  downloadConfig(api, 'startup', row.blobKey)
                }
              >
                {savedCcMsg.btnStartupConfig}
              </DownloadConfigButton>
              <DownloadConfigButton
                disabled={!row.currentConfigExists}
                downloadConfigCallback={() =>
                  downloadConfig(api, 'current', row.blobKey)
                }
              >
                {savedCcMsg.btnCurrentConfig}
              </DownloadConfigButton>
              <Button
                disabled={
                  !(
                    row.status === 'changed' &&
                    row.currentConfigExists &&
                    row.startupConfigExists
                  )
                }
                variant='tertiary'
                type='button'
                size='xxs'
                onClick={() => {
                  setDiffHost(row);
                }}
                icon='fa-file-plus-minus'
                iconStyle='regular'
              >
                {savedCcMsg.btnChanges}
              </Button>
            </div>
          ),
        }),
      ],
    }),
  });

  return (
    <>
      <ApiTablePage
        endpoint={endpoint}
        tableClassName='m'
        additionalApiTableProps={{
          enableIntentEditor: true,
        }}
      />
      {diffHost && (
        <SavedConfigConsistencyDiffModal
          hostname={diffHost.hostname}
          blobKey={diffHost.blobKey}
          onClose={() => {
            setDiffHost(null);
          }}
        />
      )}
    </>
  );
};
